import { gql } from "@apollo/client";

export const GET_PRODUCTS = (language) => gql`
  query ($productType: Int, $searchInput: String, $category: ID, $page: Int,  $marque: ID) {
    products(
      filters: {
        and: [
          { productType: { eq: $productType } }
          { ${
            language === "en" ? "name_en" : "name"
          }: { containsi: $searchInput } }
          { category: { id: { eq: $category } } }
          { marque: { id: { eq: $marque } } }
        ]
      }
      sort: "createdAt:desc"
      pagination: { page: $page, pageSize: 10 }
    ) {
      meta {
        pagination {
          total
          page
          pageSize
        }
      }
      data {
        id
        attributes {
          name
          name_en
          archived
          buyingPrice
          retailerPriceHT
          publicPriceTTC
          discountHT
          discountTTC
          discountStartDate
          discountEndDate
          description
          description_en
          reference
          productType
          packings(pagination: { pageSize: 1000000 }) {
            data {
              id
              attributes {
                sold
                cuve
                panel
                serialNumber
                retailerPriceHT
                publicPriceTTC
                approvisionnement {
                  data {
                    id
                    attributes {
                      arrivalDate
                      estimatedDate
                    }
                  }
                }
              }
            }
          }
          category {
            data {
              id
              attributes {
                name
              }
            }
          }
          gamme {
            data {
              id
              attributes {
                name
              }
            }
          }
          attachments {
            data {
              id
              attributes {
                file {
                  data {
                    id
                    attributes {
                      url
                      mime
                      name
                    }
                  }
                }
                videoUrl
              }
            }
          }
          caracteristique {
            data {
              id
            }
          }
          light_sensor_serie {
            data {
              id
            }
          }
          equipement {
            data {
              id
            }
          }
        }
      }
    }
  }
`;
export const GET_ONE_PRODUCT = gql`
  query ($id: ID!) {
    product(id: $id) {
      data {
        id
        attributes {
          name
          name_en
          buyingPrice
          kangourou
          productType
          retailerPriceHT
          publicPriceTTC
          discountHT
          discountTTC
          discountStartDate
          discountEndDate
          description
          description_en
          reference
          multipleContainer
          accessoryWeight
          accessoryDimension
          adminOnly
          product_size {
            data {
              id
              attributes {
                name
              }
            }
          }
          delivery_types {
            data {
              id
              attributes {
                name
              }
            }
          }
          related_products {
            data {
              id
              attributes {
                name
              }
            }
          }
          accessories {
            data {
              id
              attributes {
                name
                attachments {
                  data {
                    id
                    attributes {
                      title
                      file {
                        data {
                          id
                          attributes {
                            url
                            mime
                            name
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          packings(pagination: { pageSize: 1000000 }) {
            data {
              id
              attributes {
                sold
                cuve
                panel
                serialNumber
                retailerPriceHT
                publicPriceTTC
                approvisionnement {
                  data {
                    id
                    attributes {
                      arrivalDate
                      estimatedDate
                    }
                  }
                }
              }
            }
          }
          caracteristique {
            data {
              id
              attributes {
                capacity
                productDimensions
                palletizedDimensions
                weight
                hydrotherapyJet
                waterPump
                filtrationPump
                dashboardComputer
                balboaElectricBox
                balboaHeater
                electricalPowerSource
                swimJetPump
                waterVolume
                extraFields
              }
            }
          }
          equipement {
            data {
              id
              attributes {
                acrylicsARISTECH
                systemeBiolok
                desinfection
                filtrationCartouche
                filtrationBasseConsommation
                isolation
                baseABS
                systemeAudio
                hautParleur
                name
                powerController
                easyDrain
                winterCover
                cascade
              }
            }
          }
          light_sensor_serie {
            data {
              id
              attributes {
                sportChromotherapie
                LEDsLigneEau
                jetsRetroEclaires
                backlitCorners
                backlitPanels
                backlitSkimmer
                backlitToggleSwitch
                backlitRegulators
                backlitWaterfall
                backlitRiver
                backlitNeckSupport
              }
            }
          }
          attachments(pagination: { limit: -1 }) {
            data {
              id
              attributes {
                title
                file {
                  data {
                    id
                    attributes {
                      url
                      mime
                      name
                    }
                  }
                }
                videoUrl
                date
                type
                icon
              }
            }
          }
          category {
            data {
              id
              attributes {
                name
              }
            }
          }
          gamme {
            data {
              id
              attributes {
                name
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_PRODUCTS_ACCESSORIES = gql`
  query ($id: ID) {
    products(
      filters: { related_products: { id: { eq: $id } }, productType: { eq: 2 } }
      sort: "createdAt:asc"
      pagination: { page: 1, pageSize: 100000 }
    ) {
      meta {
        pagination {
          total
          page
          pageSize
        }
      }
      data {
        id
        attributes {
          name
          name_en
          buyingPrice
          retailerPriceHT
          publicPriceTTC
          description
          description_en
          reference
          productType
          packings(pagination: { pageSize: 1000000 }) {
            data {
              id
              attributes {
                sold
                cuve
                panel
                serialNumber
                retailerPriceHT
                publicPriceTTC
                approvisionnement {
                  data {
                    id
                    attributes {
                      arrivalDate
                      estimatedDate
                    }
                  }
                }
              }
            }
          }
          category {
            data {
              id
              attributes {
                name
              }
            }
          }
          gamme {
            data {
              id
              attributes {
                name
              }
            }
          }
          attachments {
            data {
              id
              attributes {
                file {
                  data {
                    id
                    attributes {
                      url
                      mime
                      name
                    }
                  }
                }
                videoUrl
              }
            }
          }
          caracteristique {
            data {
              id
            }
          }
          light_sensor_serie {
            data {
              id
            }
          }
          equipement {
            data {
              id
            }
          }
        }
      }
    }
  }
`;

export const GET_ACCESSORY_RELATED_PRODUCTS = gql`
  query ($id: ID) {
    products(
      filters: { accessories: { id: { eq: $id } } }
      sort: "createdAt:asc"
      pagination: { page: 1, pageSize: 100000 }
    ) {
      meta {
        pagination {
          total
          page
          pageSize
        }
      }
      data {
        id
        attributes {
          name
          name_en
          buyingPrice
          retailerPriceHT
          publicPriceTTC
          description
          description_en
          reference
          productType
          attachments {
            data {
              id
              attributes {
                file {
                  data {
                    id
                    attributes {
                      url
                      mime
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
